export default __webpack_public_path__ + "static/media/pumpkin.0761da25.png";